/**
 * 觸覺回饋。
 *
 * 走 Vibration API，**Android 有效、iOS Safari 不支援**（含安裝成 PWA 後）。
 * 因此它只能是錦上添花：任何操作都不可以只靠震動傳達結果，畫面上仍要有對應的視覺回饋。
 *
 * 不支援的環境靜默略過——這是裝置能力差異，不是錯誤，不該讓呼叫端寫 try/catch。
 */

/** 各情境的震動長度（毫秒）。刻意都很短：超過 ~20ms 會從「回饋」變成「震動提醒」。 */
/* 用 satisfies 而非 as const：as const 會把陣列推成 readonly tuple，
   而 vibrate() 的簽章要的是可變的 number[] */
const PATTERNS = {
  /** 一般點擊：切換選項、套用常吃品項 */
  tap: 10,
  /** 操作成功送出 */
  success: [10, 40, 20],
  /** 操作失敗或被拒絕 */
  error: [30, 60, 30],
} satisfies Record<string, VibratePattern>;

export type HapticPattern = keyof typeof PATTERNS;

/**
 * 播放一段觸覺回饋。
 *
 * @example
 * haptic('tap');      // 切換餐別
 * haptic('success');  // 紀錄存檔完成
 */
export function haptic(pattern: HapticPattern = 'tap'): void {
  /* SSR／靜態產生時沒有 navigator；不支援的瀏覽器也沒有 vibrate */
  if (typeof navigator === 'undefined' || !('vibrate' in navigator)) return;

  navigator.vibrate(PATTERNS[pattern]);
}
